var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class News extends Component {
    constructor() {
        super('News', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('resize', () => {
                this.resizeImage();
            });
            this.resizeImage();
            setTimeout(() => {
                this.resizeImage();
            }, 1000);
            this.success();
        });
    }
    resizeImage() {
        const imageHeight = $(window).width() < 768 ? $('.module-news__image').width() / 1.33 : $('.module-news__content').height() + 128;
        $('.module-news__image').css('height', imageHeight);
    }
}
